import { useContext, useEffect, useState } from "react";
import { CategoryOfFixedAssetDto } from "../../../../dtos/catalogs/CategoryOfFixedAsset/CategoryOfFixedAssetDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import CategoryOfFixedAssetDetailSkeleton from "./CategoryOfFixedAssetDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import CategoryOfFixedAssetDetailMain from "./CategoryOfFixedAssetDetailMain";

interface IProps {
  model: CategoryOfFixedAssetDto | null;
  modelUpdatedEvent: (newModel: CategoryOfFixedAssetDto) => void;
}

interface CategoryOfFixedAssetModel {
  name: string;
  id: string;
  description?: string;
  code?: string;
  accountingAccount?: string;
  depreciationAccount?: string;
  expensesAccount?: string;
  depreciationMethod?: string;
  usefulLife?: number;
}

export const CategoryOfFixedAssetDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<CategoryOfFixedAssetModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;

  useEffect(() => {
    if (model) {
      setValue("name", model.name);
      setValue("description", model.description);
      setValue("code", model.code);
      setValue("accountingAccount", model.accountingAccount);
      setValue("depreciationAccount", model.depreciationAccount);
      setValue("expensesAccount", model.expensesAccount);
      setValue("depreciationMethod", model.depreciationMethod);
      setValue("usefulLife", model.usefulLife);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: CategoryOfFixedAssetModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: CategoryOfFixedAssetDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
  };

  if (!model) {
    return (
      <>
        <CategoryOfFixedAssetDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <CategoryOfFixedAssetDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};

export default CategoryOfFixedAssetDetail;
